const RegimenFiscalCatalog = [
  {
    "clave": 601,
    "descripcion": "General de Ley Personas Morales",
    "fisica": "No",
    "moral": "Sí",
    "uso_cfdi": "G01, G02, G03, I01, I02, I03, I04, I05, I06, I07, I08, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 603,
    "descripcion": "Personas Morales con Fines no Lucrativos",
    "fisica": "No",
    "moral": "Sí",
    "uso_cfdi": "G01, G02, G03, I01, I02, I03, I04, I05, I06, I07, I08, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 605,
    "descripcion": "Sueldos y Salarios e Ingresos Asimilados a Salarios",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "D01, D02, D03, D04, D05, D06, D07, D08, D09, D10, S01, CP01, CN01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 606,
    "descripcion": "Arrendamiento",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "G01, G02, G03, I01, I02, I03, I04, I05, I06, I07, I08, D01, D02, D03, D04, D05, D06, D07, D08, D09, D10, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 607,
    "descripcion": "Régimen de Enajenación o Adquisición de Bienes",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "D01, D02, D03, D04, D05, D06, D07, D08, D09, D10, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 608,
    "descripcion": "Demás ingresos",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "D01, D02, D03, D04, D05, D06, D07, D08, D09, D10, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 609,
    "descripcion": "Consolidación",
    "fisica": "No",
    "moral": "Sí",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": "2019-12-31"
  },
  {
    "clave": 610,
    "descripcion": "Residentes en el Extranjero sin Establecimiento Permanente en México",
    "fisica": "Sí",
    "moral": "Sí",
    "uso_cfdi": "S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 611,
    "descripcion": "Ingresos por Dividendos (socios y accionistas)",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "D01, D02, D03, D04, D05, D06, D07, D08, D09, D10, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 612,
    "descripcion": "Personas Físicas con Actividades Empresariales y Profesionales",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "G01, G02, G03, I01, I02, I03, I04, I05, I06, I07, I08, D01, D02, D03, D04, D05, D06, D07, D08, D09, D10, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 614,
    "descripcion": "Ingresos por intereses",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "D01, D02, D03, D04, D05, D06, D07, D08, D09, D10, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 615,
    "descripcion": "Régimen de los ingresos por obtención de premios",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "D01, D02, D03, D04, D05, D06, D07, D08, D09, D10, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 616,
    "descripcion": "Sin obligaciones fiscales",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 620,
    "descripcion": "Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
    "fisica": "No",
    "moral": "Sí",
    "uso_cfdi": "G01, G02, G03, I01, I02, I03, I04, I05, I06, I07, I08, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 621,
    "descripcion": "Incorporación Fiscal",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "G01, G02, G03, I01, I02, I03, I04, I05, I06, I07, I08, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 622,
    "descripcion": "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
    "fisica": "No",
    "moral": "Sí",
    "uso_cfdi": "G01, G02, G03, I01, I02, I03, I04, I05, I06, I07, I08, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 623,
    "descripcion": "Opcional para Grupos de Sociedades",
    "fisica": "No",
    "moral": "Sí",
    "uso_cfdi": "G01, G02, G03, I01, I02, I03, I04, I05, I06, I07, I08, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 624,
    "descripcion": "Coordinados",
    "fisica": "No",
    "moral": "Sí",
    "uso_cfdi": "G01, G02, G03, I01, I02, I03, I04, I05, I06, I07, I08, S01, CP01",
    "inicio_de_vigencia": "2016-11-12",
    "fin_de_vigencia": null
  },
  {
    "clave": 625,
    "descripcion": "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "G01, G02, G03, I01, I02, I03, I04, I05, I06, I07, I08, D01, D02, D03, D04, D05, D06, D07, D08, D09, D10, S01, CP01",
    "inicio_de_vigencia": "2020-06-01",
    "fin_de_vigencia": null
  },
  {
    "clave": 626,
    "descripcion": "Régimen Simplificado de Confianza",
    "fisica": "Sí",
    "moral": "Sí",
    "uso_cfdi": "G01, G02, G03, I01, I02, I03, I04, I05, I06, I07, I08, S01, CP01",
    "inicio_de_vigencia": "2022-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": 628,
    "descripcion": "Hidrocarburos",
    "fisica": "No",
    "moral": "Sí",
    "uso_cfdi": "P01",
    "inicio_de_vigencia": "2024-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": 629,
    "descripcion": "De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "P01",
    "inicio_de_vigencia": "2024-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": 630,
    "descripcion": "Enajenación de acciones en bolsa de valores",
    "fisica": "Sí",
    "moral": "No",
    "uso_cfdi": "P01",
    "inicio_de_vigencia": "2024-01-01",
    "fin_de_vigencia": null
  },
];

export {
  RegimenFiscalCatalog
};